import createCachedSelector from 're-reselect';
import { createSelector } from '@reduxjs/toolkit';

import type { ReduxState } from 'app/redux/types';

import type { RecordOfConflict } from '../records';
import { selectConflictState } from './state';

// ---

export const selectHasConflict = (state: ReduxState): boolean => {
  return selectConflictState(state) !== null;
};

export const selectLastTriggeredTimeState = (state: ReduxState): RecordOfConflict['lastTriggeredTime'] => {
  return selectConflictState(state)?.lastTriggeredTime ?? null;
};

export const selectIsConflictedEntry = (state: ReduxState, betId: number): boolean => {
  const conflict = selectConflictState(state);

  return (conflict !== null) && conflict.highlightEntryIds.has(betId);
};

export const selectAllConflictedIds = createSelector(
  selectConflictState,
  (conflict) => {
    let ids = new Set<number>();

    if (!conflict) {
      return ids;
    }

    const { items, highlightEntryIds } = conflict;

    ids = new Set([...highlightEntryIds]);

    items.forEach((_item, id) => {
      ids.add(id);
    });

    return ids;
  },
);

export const selectIsConflictedMatch = createCachedSelector(
  (_state: ReduxState, matchId: number) => matchId,
  selectConflictState,
  (matchId, conflict) => {
    if (conflict === null) {
      return false;
    }

    const foundConflictedMatch = conflict.items.find((conflictedEntry) => (
      conflictedEntry.bet.entity.matchId === matchId
    ));

    return Boolean(foundConflictedMatch);
  },
)((_state: ReduxState, matchId: number) => matchId);
